import Lottie from 'lottie-react';
import type { FC } from 'react';

import { LottieAnimateOnView } from '../LottieAnimateOnView';
import type { LottieAnimationProps } from '../types';

import sparklingBadgeData from './SparklingBadge.json';

export const SparklingBadgeAnimation: FC<LottieAnimationProps> = ({
  animateOnView,
  ...restProps
}) => {
  const Animation = (
    <Lottie {...restProps} animationData={sparklingBadgeData} />
  );

  if (!animateOnView) {
    return Animation;
  }

  return <LottieAnimateOnView>{Animation}</LottieAnimateOnView>;
};
